import { render } from "./UploadCasePopUp.vue?vue&type=template&id=f6f0dec8&scoped=true&ts=true"
import script from "./UploadCasePopUp.vue?vue&type=script&lang=ts"
export * from "./UploadCasePopUp.vue?vue&type=script&lang=ts"

import "./UploadCasePopUp.vue?vue&type=style&index=0&id=f6f0dec8&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f0dec8"]])

export default __exports__